const LOGO = "/brand/neec-digital-logo.png";

export function Brand({ light }) {
  return (
    <div className="flex items-center gap-3" data-testid="neec-brand">
      <div className={`shrink-0 rounded-xl p-1.5 ${light ? "bg-white" : "bg-slate-50 border border-slate-200"}`}>
        <img src={LOGO} alt="NEEC Digital" className="h-10 w-10 object-contain" data-testid="neec-digital-logo" />
      </div>
      <div className="leading-tight">
        <div className={`font-display font-bold text-lg ${light ? "text-white" : "text-slate-900"}`}>NEEC Service</div>
        <div className={`text-[11px] font-semibold tracking-widest uppercase ${light ? "text-slate-400" : "text-slate-500"}`}>by NEEC Digital</div>
      </div>
    </div>
  );
}

export function AuthCard({ children, testId }) {
  return (
    <div className="min-h-screen bg-[#0B192C] grid place-items-center p-4" data-testid={testId}>
      <div className="w-full max-w-md bg-white rounded-2xl p-6 sm:p-8 fade-up">
        <div className="mb-6 p-3 rounded-xl bg-slate-50 border border-slate-200"><Brand /></div>
        {children}
      </div>
    </div>
  );
}
